import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;

  @media screen and (min-width: 640px) {
    flex-grow: 0;
  }
`;

export const Heading = styled.p`
  font-family: opensans-regular;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #333333;
  margin: 16px 0;
`;

export const Form = styled.form`
  width: 100%;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;

  &:last-of-type {
    margin-top: 10px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  margin-top: 42px;
  align-items: center;
`;

export const Label = styled.label`
  font-family: opensans-regular, helvetica, arial, sans-serif;
  text-align: left;
  font-size: 14px;
  margin-bottom: 8px;
  display: inline-block;
  color: #666;
`;

export const Image = styled.img`
  padding: 10px 0;
`;
